import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=5c7d48f0"
import script from "./frame.vue?vue&type=script&lang=js"
export * from "./frame.vue?vue&type=script&lang=js"
import style0 from "./frame.vue?vue&type=style&index=0&id=5c7d48f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports